import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="bg-paper">
      <section id="about-start" data-guide-label="About" className="mx-auto max-w-3xl px-6 py-24">
        <p className="font-display text-xs uppercase tracking-[0.25em] text-accent">
          About
        </p>
        <h1 className="mt-3 font-display text-4xl leading-tight tracking-tight md:text-5xl">
          A finance operator-builder, still ascending.
        </h1>
        <div className="prose prose-lg mt-8 max-w-none text-ink/80">
          <p>
            I'm JL Patawaran — an AI-augmented finance professional building
            at the intersection of accounting craft, systems design, and
            founder-facing judgment. I am not claiming the top. I am building
            toward it with useful evidence and a learning rhythm that compounds.
          </p>
          <p>
            How I think about the work: books are not just records, they are
            an instrument of trust. Close is not just a process, it is a
            practice of attention. Reporting is not decoration, it is how
            clarity enters decisions that would otherwise run on guesswork.
          </p>
          <h2 id="what-i-bring" data-guide-label="What I bring" className="font-display text-2xl">What I bring</h2>
          <ul>
            <li>
              <strong>Accounting craft</strong> across AP ownership, AR
              oversight, month-end close, multi-entity support, vendor and
              stakeholder communication, and expense operations.
            </li>
            <li>
              <strong>Systems building</strong> inside the work: structured
              spreadsheet tools, data models, reconciliation support, and
              lightweight workflows that remove repeat drag.
            </li>
            <li>
              <strong>AI-assisted execution</strong> for repeatable work, with
              human judgment kept close to the books, the exceptions, and the
              final delivery.
            </li>
          </ul>
          <h2 id="what-i-dont-claim" data-guide-label="What I don't claim" className="font-display text-2xl">What I don't claim</h2>
          <ul>
            <li>I'm not a CPA. I'm an operator with accounting depth.</li>
            <li>I do not replace legal, tax, or audit professionals.</li>
            <li>I do not turn private client work into public proof without approval.</li>
          </ul>
          <h2 id="building" data-guide-label="Building" className="font-display text-2xl">Building</h2>
          <p>
            <strong>Cleic</strong> is the finance operating layer I am building
            from real close, cash visibility, and reporting work. Public details
            stay intentionally simple until the product story is ready.
          </p>
          <p>Async-first. Focused on operators who need finance clarity without noise.</p>
        </div>
        <div className="mt-12">
          <Button asChild size="lg">
            <Link to="/work-with-me#prefit">Start async prefit</Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
